import { TestIdProvider } from '@ori/testid-generator';
import { ErrorBoundary } from "./ErrorBoundary";
import { APP_NAME, APP_TEAM_NAME } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var ComponentWrapper = function ComponentWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(TestIdProvider, {
      team: APP_TEAM_NAME,
      project: APP_NAME,
      children: children
    })
  });
};